<ng-container *ngIf="product()?.id; else noProductId">
    <app-customer-product-price-edit-widget [product]="product()" [dataTestid]="'formly-product-customer-product-price-edit-widget'" />
</ng-container>
<ng-template #noProductId>
    <div
        class="flex justify-center items-center choose-ngifloader-splitter"
        style="height: 100%; width: 100%; min-height: 400px"
    >
        <div class="shine">
            <h3>{{ 'product.product-choose' | translate }}</h3>
        </div>
    </div>
</ng-template>
